import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { getCsrf, login as loginApi, logout as logoutApi, me } from '../api/auth';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [status, setStatus] = useState('loading'); // 'loading' | 'authenticated' | 'unauthenticated'

    // Called on app mount & after successful login
    const refreshUser = async () => {
        try {
            const { data } = await me();
            setUser(data);
            setStatus('authenticated');
        } catch {
            setUser(null);
            setStatus('unauthenticated');
        }
    };

    const bootstrap = async () => {
        try {
            await getCsrf(); // safe to call always
        } finally {
            await refreshUser();
        }
    };

    useEffect(() => {
        bootstrap();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const login = async ({ email, password, remember }) => {
        // Ensure CSRF first (esp. after cold start)
        await getCsrf();
        await loginApi({ email, password, remember: !!remember });
        await refreshUser();
    };

    const signOut = async () => {
        try {
            await logoutApi();
        } finally {
            setUser(null);
            setStatus('unauthenticated');
        }
    };

    const value = useMemo(
        () => ({ user, status, login, signOut, refreshUser }),
        [user, status]
    );

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
